module.exports = __webpack_public_path__ + "assets/c4af8fb7.wav";